export default __webpack_public_path__ + "static/media/warning.2a7cf830.svg";